import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
//interfaces
import {
  CdFilterProps,
  DistributionCenterListProps,
  HeaderLabelQuotes,
  IDistributionCenterProps,
  TabsDistributionCenterListProps
} from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//assets
import { IconWarningItem } from "img/warning-item";
//components
import Loader from "../generics/Loader";
import { Visibility } from "components/Visibility";
import TabNavigation from "components/TabNavigation";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
import TableDetails from "../generics/Tables/Details/TableDetails";
import { eventName } from "components/ApplicationInsights/eventNames";
import { PaymentMethodsTabsProps } from "pages/Quotes/SavedInMoney/interface";
import { ButtonRow, CustomButton, CustomButtonText, LoaderContainer } from "../QuoteCategoryTab/styles";
//services
import QuoteService from 'services/quote.service';
//utils
import { newTabsOrderWithSegments } from "pages/Quotes/SavedInMoney/utils";

export const DistributionCenterTab: React.FC<IDistributionCenterProps> = (props) => {
  const {
    quoteId,
    hasMore,
    setHasMore,
    modalIsOpen,
    customerCode,
    setShouldReset,
    productSelected,
    isQuoteExpired,
    setSequenceNumber,
    setPaymentMethods,
    setRefreshControl,
    ableNegotiacionBtn,
    setProductSelected,
    setOldSegmentSelected,
    distributionCenterName,
    setQtdItemsAlreadySent,
    allBudgetsSavedInQuote,
    setRemoveAllFromToSegment,
    setIsDeparaModalDisplayed,
    distributionCenterSelected,
    setDistributionCenterSelected,
    reproveMapProduct,
    approveMapProduct
  } = props;
  const [cdFilter, setCdFilter] = useState<CdFilterProps>({ distributionCenter: '' });
  const [oldTabs, setOldTabs] = useState<DistributionCenterListProps[]>([]);
  const [firstDetailPageRender, setFirstDetailPageRender] = useState<boolean>(false);

  const location: any = useLocation();
  const _quoteService = new QuoteService();

  const { state } = location;
  const {
    quoteItem,
    quoteDetail,
    currentPage,
    setSequence,
    setQuoteItem,
    firstLoadPage,
    setQuoteDetail,
    setCurrentPage,
    setFirstLoadPage,
    secondDetailPageRender,
  } = useDetailsQuoteContext();

  const showDeParaModal = (_quoteId: string, sequenceNumber: string, sequence: number) => {
    setSequence(sequence);
    setIsDeparaModalDisplayed(true);
    setSequenceNumber(sequenceNumber);
    document.body.style.overflow = "hidden";
  };

  const updateQuoteStatus = (itemSequenceNumber: number, status: boolean) => {
    if (!quoteItem?.data) return;

    let newQuoteItems: any = quoteItem.data;

    let updatedQuoteItemIndex = quoteItem.data.findIndex(
      (item: any) => Number(item.sequenceNumber) === itemSequenceNumber
    );

    const item = quoteItem.data.find((item) => item?.productsSuggestion);
    const itemStock = item?.productsSuggestion![0]?.itemStock;

    if (updatedQuoteItemIndex === undefined) return;

    updatedQuoteItemIndex += 1;

    const distributionCenter = distributionCenterName.find((cd: any) => cd.value === item?.distributionCenter);

    const itemStockIndex = itemStock!.findIndex(
      (item: any) => item.local === distributionCenter.value
    );

    if (
      itemStockIndex === undefined ||
      !newQuoteItems[0] ||
      !newQuoteItems[0]?.productsSuggestion[0]?.itemStock[itemStockIndex]
    )
      return;

    newQuoteItems[0].productsSuggestion[0].itemStock[
      itemStockIndex
    ].blocked = status;

    setShouldReset(true);
    setQuoteItem({ ...quoteItem, data: newQuoteItems });
  };

  const refreshItem = useCallback(
    (
      field: string,
      value?: any,
      sequenceNumber?: string,
      filterDetail?: string,
      valueFilterDetail?: any
    ) => {
      if (!quoteItem?.data) return;

      const fields = field.split(".");

      let index: number = quoteItem?.data.findIndex(
        (item: any) => item.sequenceNumber == sequenceNumber
      );
      let data = Object.assign(quoteItem?.data) as Array<IQuoteDetailItem>;

      let item = {};

      type field0 = keyof typeof data[0];

      if (fields.length == 1) {
        let detailItemObj: IQuoteDetailItem = { [fields[0] as field0]: value };
        item = { ...data[index], ...detailItemObj };
      } else if (fields.length == 2) {
        const itemDetail = data[index][fields[0] as field0];
        if (!itemDetail.length) return;

        const indexDetail = itemDetail.findIndex(
          (item: any) => item[filterDetail!] == valueFilterDetail
        );

        if (indexDetail < 0) return;

        let detailItemObj = { [fields[1]]: value };
        itemDetail[indexDetail] = {
          ...itemDetail[indexDetail],
          ...detailItemObj,
        };

        item = { ...data[index], [fields[0]]: itemDetail };
      }

      data[index] = item;

      setQuoteItem({ ...quoteItem, data: data });
    }, [quoteItem]);

  const refreshQuoteSentHeaderTabs = async () => {
    const response = await _quoteService.getQuoteSentHeaderTabs(quoteId);

    if (setQuoteDetail && quoteDetail) {
      setQuoteDetail({ ...quoteDetail, distributionCentersList: response.data.data });
      newTabsOrderWithSegments(
        response.data.data,
        distributionCenterSelected,
        setDistributionCenterSelected,
        setHasMore,
        setCurrentPage,
        setQuoteItem,
        setRemoveAllFromToSegment,
        quoteDetail.distributionCentersList
      );
    }
  };

  useEffect(() => {
    if (quoteDetail) {
      const indexOldSegmentSelected = tabsRender?.find(x => x.filter.distributionCenter === distributionCenterSelected);

      if ((oldTabs.length !== tabsRender?.length && !indexOldSegmentSelected) || ((oldTabs.length === tabsRender?.length) && (oldTabs[0].distributionCenter !== tabsRender[0].filter.distributionCenter)) || !indexOldSegmentSelected) {
        setOldTabs(quoteDetail.distributionCentersList);
        setOldSegmentSelected(distributionCenterSelected);
        setFirstDetailPageRender(true);
      } else {
        setFirstDetailPageRender(false);
        setRemoveAllFromToSegment(false);
      }
    }
  }, [quoteDetail]);

  useEffect(() => {
    setFirstDetailPageRender(true);
  }, []);

  useEffect(() => {
    if (cdFilter.distributionCenter !== distributionCenterSelected) {
      setHasMore(true);
      setCurrentPage(0);
      setFirstLoadPage(true);
      setQuoteItem(undefined);
      setFirstDetailPageRender(false);
      setRemoveAllFromToSegment(true);
      setDistributionCenterSelected(cdFilter.distributionCenter);
    }
  }, [cdFilter]);

  const refreshTableWithTab = (tabs: any) => {
    setDistributionCenterSelected(tabs[0].distributionCenter);
    setHasMore(true);
    setCurrentPage(0);
    setFirstLoadPage(true);
    setQuoteItem(undefined);
    setFirstDetailPageRender(false);
    setRemoveAllFromToSegment(true);
  };

  useEffect(() => {
    if (distributionCenterSelected !== '') {
      setCdFilter({ distributionCenter: distributionCenterSelected });
      cdFilter.distributionCenter !== distributionCenterSelected && setFirstDetailPageRender(true);
    }
  }, [distributionCenterSelected]);

  const MemoQuoteDetailsTable = useMemo(() => (
    <TableDetails
      customProps={{
        getDetail: updateQuoteStatus,
        getNewItem: refreshItem,
        showModal: showDeParaModal
      }}
      state={state}
      quoteId={quoteId}
      cdFilter={cdFilter}
      setHasMore={setHasMore}
      customerCode={customerCode}
      headerLabels={HeaderLabelQuotes}
      productSelected={productSelected}
      setRefreshControl={setRefreshControl}
      ableNegotiacionBtn={ableNegotiacionBtn}
      setProductSelected={setProductSelected}
      refreshTableWithTab={refreshTableWithTab}
      distributionCenters={distributionCenterName}
      refreshQuoteSentHeaderTabs={refreshQuoteSentHeaderTabs}
      distributionCenterSelected={distributionCenterSelected}
      reproveMapProduct={reproveMapProduct}
      approveMapProduct={approveMapProduct}
    />
  ), [quoteItem, currentPage, quoteDetail, distributionCenterSelected, distributionCenterName, productSelected, quoteDetail?.distributionCentersList]);

  const tabLabel = (cd: string) => {
    switch (cd) {
      case 'default':
        return 'Não Preenchidos';
      case 'outPortfolio':
        return 'Fora de Portfólio';
      default:
        return cd;
    }
  };

  const paymentMethodsTabs: PaymentMethodsTabsProps[] = [];
  let totalItemsAlreadySent = 0;
  const tabsRender = useMemo(() => {
    if (quoteDetail?.distributionCentersList) {
      const tabs: TabsDistributionCenterListProps[] = [];

      quoteDetail?.distributionCentersList.map((option: DistributionCenterListProps) => {
        const labelTab = tabLabel(option.distributionCenter);
        const distCenter = option.distributionCenter;
        const totalItems = option.totalItems;
        const negotiationTabs = option.negotiation;
        if (option.distributionCenter !== 'default')
          totalItemsAlreadySent = totalItemsAlreadySent + totalItems;
        tabs.push({
          label: `${labelTab} (${totalItems})`,
          filter: { distributionCenter: distCenter },
          trackingName: distCenter,
          negotiation: negotiationTabs,
          previouslyAddedToBionexo: option.previouslyAddedToBionexo
        });
        paymentMethodsTabs.push({
          distributionCenter: distCenter,
          paymentMethod: option.paymentMethod ?? ''
        });
      });

      return tabs;
    }
  }, [quoteDetail]);

  useEffect(() => {
    if (tabsRender && tabsRender.length > 0) {
      setPaymentMethods(paymentMethodsTabs.filter(payment => payment.distributionCenter !== 'default'));
      setQtdItemsAlreadySent(totalItemsAlreadySent);
    }
  }, [tabsRender]);

  return (
    <>
      <TabNavigation
        singlePage
        portalNavigation
        className="mt-3"
        modalIsOpen={modalIsOpen}
        tabLabels={tabsRender ?? []}
        pages={[MemoQuoteDetailsTable]}
        isQuoteExpired={isQuoteExpired}
        trackingKey="Edição de cotações"
        productSelected={productSelected}
        trackingEvent={eventName.COTACOES}
        firstDetailPageRender={firstDetailPageRender}
        setTabFilter={(filter) => setCdFilter(filter)}
        allBudgetsSavedInQuote={allBudgetsSavedInQuote}
        distributionCenterSelected={distributionCenterSelected}
        icon={<IconWarningItem color={"#E02828"} width={20} height={16} />}
      />

      <Visibility visible={hasMore && secondDetailPageRender && !firstLoadPage}>
        <ButtonRow>
          <CustomButton onClick={() => { setCurrentPage(currentPage + 1); }}>
            <CustomButtonText>
              Carregar mais itens
            </CustomButtonText>
          </CustomButton>
        </ButtonRow>
      </Visibility>

      <Visibility visible={!secondDetailPageRender && !firstLoadPage}>
        <LoaderContainer>
          <Loader size={!quoteItem ? 45 : 35} />
        </LoaderContainer>
      </Visibility>
    </>
  );
};